import { DataBean } from "../DataBean";

export class QualityInspectionChangeParts extends DataBean {

  public async getQualityInspectionChangePartsCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionChangePartsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInspectionChangePartsRender( page: number, rows: number, properties: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInspectionChangePartsRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async deleteQualityInspectionChangeParts(idqualityinspectionchangeparts: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspectionChangeParts_Number", [idqualityinspectionchangeparts]);
  }

  public async updateQualityInspectionChangeParts(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspectionChangeParts_updateQualityInspectionChangeParts_com.orange.finance.processcontract.bean.QualityInspectionChangeParts",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspectionChangeParts",
        },
      ]
    );
  }
}
